export const SET_PRODUCT_IMAGE_COMMAND_CREATE_RESET = 'SET_PRODUCT_IMAGE_COMMAND_CREATE_RESET'
export const SET_PRODUCT_IMAGE_COMMAND_CREATE_SET_CREATED = 'SET_PRODUCT_IMAGE_COMMAND_CREATE_SET_CREATED'
export const SET_PRODUCT_IMAGE_COMMAND_CREATE_SET_ERROR = 'SET_PRODUCT_IMAGE_COMMAND_CREATE_SET_ERROR'
export const SET_PRODUCT_IMAGE_COMMAND_CREATE_SET_VIOLATIONS = 'SET_PRODUCT_IMAGE_COMMAND_CREATE_SET_VIOLATIONS'
export const SET_PRODUCT_IMAGE_COMMAND_CREATE_TOGGLE_LOADING = 'SET_PRODUCT_IMAGE_COMMAND_CREATE_TOGGLE_LOADING'
